export function getAuthErrorMessage(errorCode: string): string {
    const errorMessages: Record<string, string> = {
        'auth/email-already-in-use': 'An account with this email already exists.',
        'auth/invalid-email': 'Please enter a valid email address.',
        'auth/weak-password': 'Password should be at least 8 characters.',
        'auth/user-disabled': 'This account has been disabled. Contact support.',
        'auth/user-not-found': 'No account found with this email.',
        'auth/wrong-password': 'Incorrect password. Please try again.',
        'auth/too-many-requests': 'Too many attempts. Please try again later.',
        'auth/network-request-failed': 'Network error. Check your connection.',
        'auth/credential-already-in-use': 'This account is already linked to another user.',
        'auth/operation-not-allowed': 'This operation is not currently allowed.',
        'auth/requires-recent-login': 'Please log in again to perform this action.',
    };

    return errorMessages[errorCode] || `An unexpected error occurred (${errorCode}). Please try again.`;
}
